// extracted by mini-css-extract-plugin
export default {"page__container":"page-layout_page__container__5Z1nU","page__content":"page-layout_page__content__eB+jT"};